import React from 'react';
import { CafeService } from '@cafe/core';
import { useCafe } from '@cafe/react';

import { useAlertService, AlertService } from './alert.service';

export class ErrorService {
  constructor(
    private alertService: AlertService,
    private eventingService: CafeService
  ) {}

  public handleError(error: any): void {
    this.eventingService.logError(error.message);
    this.alertService.addAlertToList({
      level: 'danger',
      message: error.message,
      dismissible: true,
    });
    console.error(error);
  }
}

export const ERROR_SERVICE = React.createContext<ErrorService>(null!);

export function ErrorServiceProvider({ children }: React.PropsWithChildren) {
  const eventingService = useCafe<CafeService>();
  const alertService = useAlertService();
  const [errorService] = React.useState(
    () => new ErrorService(alertService, eventingService)
  );

  return (
    <ERROR_SERVICE.Provider value={errorService}>
      {children}
    </ERROR_SERVICE.Provider>
  );
}

export function useErrorService() {
  return React.useContext(ERROR_SERVICE);
}
